import { Box, Typography, withStyles } from "@material-ui/core";
import identifications from "screens/Root/utils/identifications";
import { useStartupLoading } from "./useStartupLoading";
import { useRootSelector } from "../../hooks/useAppSelector";
const loader = require("./loader.svg");
const Logo = withStyles({
    root: { fontSize: 36, transform: "translateY(50px)" },
})(Typography);
const FullscreenContainer = withStyles({
    root: {
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: "rgba(14, 115, 149, 0.9)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
    },
})(Box);
const StartupLoading = () => {
    const { appSettings, headlessLoginResult } = useRootSelector();
    const loading = useStartupLoading();
    return !loading
        ? null
        : (!headlessLoginResult
            ?
                (<FullscreenContainer data-identification={identifications.appLoading()}>
          <Logo>Application is loading...</Logo>
          <img src={loader}/>
        </FullscreenContainer>)
            :
                (<div className="arize-overlay">
            <div className="arize-spinner"></div>
          </div>));
};
export default StartupLoading;
